module.exports = __webpack_public_path__ + "img/icon_home_on.c877639f.svg";